var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "micBox"
    }
  }, [_c('i', {
    ref: "levelBox",
    staticClass: "iconfont icon-micphone bg",
    style: {
      color: _vm.isAudioLevel ? '' : '#0ed40e'
    }
  }, [_c('i', {
    ref: "level",
    staticClass: "iconfont icon-micphone level",
    style: {
      height: 100 - _vm.level.toFixed(2) * 100 + '%'
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };